import clsx from 'clsx';
import React from 'react';
import styles from './styles.css.js';
export function DarkHeaderWrapper(_a) {
    var isMobile = _a.isMobile, isRefresh = _a.isRefresh, children = _a.children, toolsWidth = _a.toolsWidth, navigationWidth = _a.navigationWidth;
    return (React.createElement("div", { className: clsx(styles['content-header'], isRefresh && 'awsui-context-content-header', isRefresh && styles['content-header-refresh']), style: isRefresh && !isMobile
            ? {
                paddingLeft: navigationWidth,
                marginLeft: -1 * navigationWidth,
                paddingRight: toolsWidth,
                marginRight: -1 * toolsWidth
            }
            : {} }, children));
}
//# sourceMappingURL=dark-header-wrapper.js.map